export const PROMO_PHRASES = [
    "Entradas oficiales, sin vueltas.",
    "Nuevos eventos cada semana en PassEvent.",
    "Comprá rápido y asegurá tu lugar.",
    "Tu próxima salida empieza acá.",
];

const PromoTicker = () => {
    const marqueeItems = [...PROMO_PHRASES, ...PROMO_PHRASES];

    return (
        <section className="relative z-30 mt-4 w-full">
            <div className="ticker-shell overflow-hidden rounded-xl border border-rose-500/25 bg-zinc-950/85 shadow-[0_12px_35px_rgba(0,0,0,0.45)] backdrop-blur-md">
                <div className="ticker-track">
                    {marqueeItems.map((phrase, idx) => (
                        <span key={`${phrase}-${idx}`} className="ticker-item">
                            {phrase}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PromoTicker;
